var render, staticRenderFns
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports